export const SHARE_SURVEY_ENDPOINTS = {
  INVITE: (id) => `/survey-manager/share-survey/${id}/invite`,
  INVITE_SUGGESTIONS: "/survey-manager/share-survey/invite-suggestions",
};
